module.exports = __webpack_public_path__ + "f9657df80af575555b22adbe6f7b5020.png";